// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, message } from 'antd';
import AppHeader from './components/header'; // 修正路径
import AppFooter from './components/footer'; // 修正路径
import Home from './pages/Home';
import Archive from './pages/Archive';
import About from './pages/About';
import Auth from './pages/Auth';
import WritePost from './pages/WritePost';
import PostDetail from './pages/PostDetail';
import NotFound from './pages/NotFound';
import { getRecentPosts, getArchivePosts, getPostById, createPost, updatePost, getAboutInfo, updateAboutInfo } from './api/mockData'; // 修正API导入
import './App.css';

const { Content } = Layout;

function App() {
  // 默认设置为已登录状态
  const [loggedInUser, setLoggedInUser] = useState({ username: 'admin', id: 1 });
  const [aboutInfo, setAboutInfo] = useState({
    name: '张三',
    avatar: '/default-avatar.png',
    intro: '前端开发者，热爱技术分享',
    details: '欢迎来到我的博客！',
    email: 'zhangsan@example.com',
    techStack: 'React, JavaScript, Node.js',
    hobbies: '阅读、旅行、摄影',
    github: 'https://github.com/zhangsan',
    personalHomepage: 'https://zhangsan.com'
  });

  const handleLogout = () => {
    // 提示用户无法退出登录，或重定向到首页
    message.info('此应用始终保持登录状态');
  };

  const handleUpdateAboutInfo = (newInfo) => {
    setAboutInfo(prev => ({ ...prev, ...newInfo }));
    message.success('个人信息更新成功');
  };

  return (
    <Router>
      <Layout className="blog-layout">
        <AppHeader onLogout={handleLogout}/>
        
        <Content className="app-content">
          <Routes>
            <Route path="/" element={
              <Home 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="/archive" element={
              <Archive 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="/about" element={
              <About 
                aboutInfo={aboutInfo} 
                onUpdateAboutInfo={handleUpdateAboutInfo}
                loggedInUser={loggedInUser}
                onLogout={handleLogout}
              />
            } />
            <Route path="/auth" element={
              <Navigate to="/" />
            } />
            <Route path="/write" element={
              <WritePost 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout}
              />
            } />
            <Route path="/post/:id" element={
              <PostDetail 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="/notfound" element={
              <NotFound 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="*" element={<Navigate to="/notfound" />} />
          </Routes>
        </Content>
        
        <AppFooter />
      </Layout>
    </Router>
  );
}

export default App;